<div class="flex flex-row items-center justify-between gap-4 pr-4">  
    <app-search-bar placeholder="Search by ID Number" class="fleet_search gt-xs:grow-0 gt-xs:shrink gt-xs:basis-[300px] xs:basis-full" inputId="fleet-search" (filterChange)="filterData($event)"></app-search-bar>
    <div class="flex gap-4">
        <button mat-button class="btn-default btn-md" (click)="openAddVmDialog()">Add Customer VM</button>
        <button mat-mini-fab class="!bg-transparent !shadow-none hover:!bg-gray-200" (click)="refreshDevices()">
            <mat-icon>refresh</mat-icon>
        </button>
    </div>
</div>
<div class="flex flex-row">
    <div class="p-l-16 p-r-16 basis-full">    
        <div class="fleet_scroll">
            <!-- Fleet mgmt grid -->
            <table mat-table [dataSource]="dataSource" matSort #sort="matSort"  matSortActive="idName" matSortDirection="asc" 
            class="prepro_table" (matSortChange)="announceSortChange($event)" tabindex="0" role="table">

                <!-- friendlyName -->
                <ng-container matColumnDef="idName" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by ID Number">
                        ID Number
                    </th>
                    <td mat-cell *matCellDef="let element"  [innerHTML]="element.edgeDeviceId | noHtml | highlightMatched: filterText" >  </td>
                </ng-container>

                <!-- Device Type -->
                <ng-container matColumnDef="deviceType">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Device Type">
                        Device Type
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.deviceType}} </td>
                </ng-container>

                <!-- Mac Address -->
                <ng-container matColumnDef="macAddress">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Mac Address">
                        Mac Address
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.macAddress}} </td>
                </ng-container>

                <!-- OS Distro -->
                <ng-container matColumnDef="osDistro">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by OS Distro">
                        OS Distro
                    </th>
                    <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                        <div *ngIf="editingOsDistroRow !== element" class="flex items-center gap-1">
                            <span>{{element.osDistro}}</span>
                            <button *ngIf="canEditOsDistro" mat-icon-button aria-label="Edit OS Distro" (click)="editingOsDistroRow = element">
                                <mat-icon>edit</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="editingOsDistroRow === element" class="flex items-center gap-1">
                            <mat-select
                                [value]="element.osDistro"
                                (selectionChange)="onOsDistroChange(element, $event.value)"
                                class="os_distro_select">
                                <mat-option [value]="null">-- None --</mat-option>
                                <mat-option *ngFor="let opt of osDistroOptions" [value]="opt" class="os_distro_select">{{opt}}</mat-option>
                            </mat-select>
                            <button mat-icon-button aria-label="Cancel edit" (click)="cancelOsDistroEdit()">
                                <mat-icon class="cancel_icon">cancel</mat-icon>
                            </button>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="connected">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Connected">
                        Connected
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span *ngIf="element.connectionState === 'Online'" class="flex">{{element.connectionState}} </span>
                        <span *ngIf="element.connectionState !== 'Online'" class="flex text-error">
                            <img class="alert_icon" src="../../../../../assets/img/icons/ico.16.alert.svg" alt="Alert">{{element.connectionState}}
                        </span>                    
                    </td>
                </ng-container>

                <ng-container matColumnDef="lastUpdated">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Last Updated">
                        Last Updated
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.connectionStateUpdatedTime | date:'dd-MMM-YYYY, h:mm aa'}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" tabindex="0" (keydown.enter)="openSystemConfigDialog(row)" (click)="openSystemConfigDialog(row)"></tr>
            </table>
            <table class="no-result" *ngIf="dataSource?.data?.length==0">
                <tr>
                    <td [attr.colspan]="displayedColumns.length">
                      <span>No data exists</span>                                          
                    </td>
                </tr>        
            </table>
        </div>        
    </div>
</div>